module.exports = __webpack_public_path__ + "static/media/BulkReturn6.6a858a72.png";